export default __webpack_public_path__ + "static/media/pokedex.79a9d098.svg";